import { get, push, ref, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetCustomersData from "../../../Comman/GetCustomersData";

const AddAssignerUserCustomerDataInFirebase = async (state, dispatch, customerData, userID, islocal, ownerUid) => {


    const USERID = state?.USERID || userID;

    if (!USERID) return null;


    try {
        const customerRef = ref(database, `invoiceGenerator/users/${ownerUid}/customers`);
        const snapshot = await get(customerRef);
        const existingCustomers = snapshot.val();

        let isCustomerExist = false;
        let existingCustomerKey = null;
        let existingCustomerData = null;

        if (!islocal && snapshot.exists()) {
            Object.entries(existingCustomers).forEach(([key, customer]) => {
                if (
                    customer.customer?.toLowerCase() === customerData.customer?.toLowerCase()
                ) {
                    isCustomerExist = true;
                    existingCustomerKey = key;
                    existingCustomerData = customer;
                }
            });
        }

        const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";

        if (!isCustomerExist) {
            const cleanedCustomer = {
                ...customerData,
                createdBy: actorName,
                createdById: state?.USERID || null,
                updatedBy: actorName,
                updatedById: state?.USERID || null,
                customerId: customerData.customerId?.toString() || Math.floor(new Date().getTime()).toString(),
                createdAt: Date.now().toString(),
                updatedAt: Date.now().toString(),
                invoiceCount: "1",
                currency: customerData?.currency?.toString() || "",
                //invoices: [customerData.invoices?.[0] || ""],
                totalPaid: "0"
            };
            await push(customerRef, cleanedCustomer);

        } else {
            const itemUpdateRef = ref(database, `invoiceGenerator/users/${ownerUid}/customers/${existingCustomerKey}`);
            await update(itemUpdateRef, {
                ...existingCustomerData,
                updatedBy: actorName,
                dialCode: customerData?.dialCode || customerData?.dial_code,
                phone: customerData?.phone,
                email: customerData?.email,
                address: customerData?.address,
                customerGSTNo: customerData?.customerGSTNo,
                updatedAt: Date.now()?.toString(),
                currency: customerData?.currency?.toString() || "",
            });

        }

        await GetCustomersData(state, dispatch);

    } catch (error) {
        console.log("eror to fetching data", error)
        return null;
    }
};

export default AddAssignerUserCustomerDataInFirebase;
